import { DayModifiers } from 'react-day-picker';

const areModifiersEqual = (
  prevModifiers: DayModifiers | {},
  nextModifiers: DayModifiers | {},
) => {
  if (Object.keys(prevModifiers).length !== Object.keys(nextModifiers).length) {
    return false;
  }

  return Object.keys(prevModifiers).every(
    modifier => prevModifiers[modifier] === nextModifiers[modifier],
  );
};

export default areModifiersEqual;
